import {
	Serializer,
	UISerializableInsuranceFundStakeRecord,
} from '@drift/common';
import { getIfStakingHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useIfStakingHistory =
	(): HistoryTableUIProps<UISerializableInsuranceFundStakeRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'if-staking',
			Serializer.Deserialize.UIInsuranceFundStakeRecord
		);

		return {
			executePageChange,
			filterFn: getIfStakingHistoryFilter,
			historyData,
		};
	};
